// extracted by mini-css-extract-plugin
export default {"users":"users_users__sui-P","userWelCard":"users_userWelCard__ChO-8","userTableCard":"users_userTableCard__wd1vP"};